import { AutocompleteInput, ReferenceInput } from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const accountPayableHistoryFilterList = (permissions) => {
  const defaultFilter = [
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      variant="outlined"
      label="mine.label.start_date"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      variant="outlined"
      label="mine.label.end_date"
      minDateSource="start_date"
    />,
    <ReferenceInput
      alwaysOn
      source="start_created_at"
      reference="suppliers"
      sort={{ field: "suppliers.created_at", order: "ASC" }}
      perPage={10}
    >
      <AutocompleteInput
        resettable
        optionValue="created_at"
        optionText="code"
        variant="outlined"
        label="mine.label.start_code"
      />
    </ReferenceInput>,
    <ReferenceInput
      alwaysOn
      source="end_created_at"
      reference="suppliers"
      sort={{ field: "suppliers.created_at", order: "ASC" }}
      perPage={10}
    >
      <AutocompleteInput
        resettable
        optionValue="created_at"
        optionText="code"
        variant="outlined"
        label="mine.label.end_code"
        // filterToQuery={(search) => ({ created_at: search })}
      />
    </ReferenceInput>,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.unshift(
      // defaultFilter.splice(
      // 1,
      // 0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};

export default accountPayableHistoryFilterList;
